export default __webpack_public_path__ + "static/media/jab_cross.ed74df19.gif";